import { apiRequest } from "../api/apiClient";

const ROUTE_PREFIX = "slots";

const getSlots = async (city: string, country: string, date: string) => {
  const params = new URLSearchParams();
  params.append("city", city);
  params.append("country", country);
  params.append("date", date);

  const query = params.toString();

  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}?${query}`);

  return { data, error };
};

const lockSlot = async (
  city: string,
  country: string,
  date: string,
  slotTime: string,
  previousSlotTime = ""
) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}/lock`, {
    city,
    country,
    date,
    slotTime,
    previousSlotTime,
  });

  return { data, error };
};

const unlockSlot = async (
  city: string,
  country: string,
  date: string,
  slotTime: string
) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}/unlock`, {
    city,
    country,
    date,
    slotTime,
  });

  return { data, error };
};

export { getSlots, lockSlot, unlockSlot };
